
export default function HowItWorks() {
  const steps = [
    {
      step: 'STEP 1: AI INTAKE',
      title: 'Tell Our AI What You Want',
      description: 'Our proprietary AI system asks you smart questions about your vehicle preferences, budget, timeline, and financing needs. It takes just 2 minutes and learns exactly what you\'re looking for.',
      image: 'https://public.readdy.ai/ai/img_res/90a2f550d024b318d3d4eb0f44759d73.jpg',
      bgColor: 'bg-white',
      labelColor: 'bg-gradient-to-r from-yellow-400 to-green-400'
    },
    {
      step: 'STEP 2: BROKER MAGIC',
      title: 'We Negotiate With Executives',
      description: 'I personally contact top-level executives at 50+ dealerships across Ontario. Using my established relationships and negotiation expertise, I secure deals that aren\'t available to the public.',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20handshake%20between%20automotive%20executives%20in%20modern%20dealership%20office%20with%20luxury%20cars%20in%20background%20warm%20professional%20lighting%20clean%20simple%20background%20emphasizing%20trust%20and%20partnership&width=800&height=600&seq=negotiation-001&orientation=landscape',
      bgColor: 'bg-gradient-to-br from-gray-800 to-gray-900',
      labelColor: 'bg-gradient-to-r from-yellow-400 to-green-400',
      textWhite: true
    },
    {
      step: 'STEP 3: YOU WIN',
      title: 'Drive Away Saving Thousands',
      description: 'You get the exact vehicle you want at a price that saves you thousands of dollars. No dealership visits, no pressure, no hassle. Just a great deal delivered to you.',
      image: 'https://readdy.ai/api/search-image?query=happy%20customer%20receiving%20car%20keys%20from%20professional%20broker%20in%20front%20of%20brand%20new%20luxury%20vehicle%20in%20bright%20modern%20showroom%20celebrating%20successful%20purchase%20with%20smiles%20clean%20simple%20background&width=800&height=600&seq=delivery-001&orientation=landscape',
      bgColor: 'bg-white',
      labelColor: 'bg-gradient-to-r from-yellow-400 to-green-400'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <header className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-8">
          <div>
            <div className="text-gray-400 text-3xl font-bold tracking-widest mb-2">HOW IT WORKS</div>
            <h2 className="text-5xl font-bold italic text-gray-900">Powered by <strong>AI Intelligence</strong></h2>
          </div>
          <div className="md:w-2/5">
            <p className="text-lg text-gray-700 leading-relaxed">
              Our proprietary <strong>AI system</strong> learns your preferences, budget, and timeline to match you with the perfect vehicle while our human expertise negotiates directly with <strong>dealership executives</strong>.
            </p>
          </div>
        </header>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <article
              key={index}
              className={`${step.bgColor} rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all group`}
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={step.image}
                  alt={`${step.title} - Auto Broker Process`}
                  title={`${step.step} Auto Broker Woodbridge`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-6 left-6">
                  <div className={`${step.labelColor} text-gray-900 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider`}>
                    {step.step}
                  </div>
                </div>
              </div>
              <div className="p-8">
                <h3 className={`text-2xl font-bold mb-4 ${step.textWhite ? 'text-white' : 'text-gray-900'}`}>
                  {step.title}
                </h3>
                <p className={`leading-relaxed ${step.textWhite ? 'text-gray-300' : 'text-gray-700'}`}>
                  {step.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* Process Timeline */}
        <div className="mt-20 bg-gradient-to-r from-purple-50 to-cyan-50 rounded-3xl p-12">
          <h4 className="text-3xl font-bold text-gray-900 text-center mb-12">
            <a href="#how-it-works" className="hover:text-purple-600 transition-colors">
              From First Contact to Keys in Hand
            </a>
          </h4>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { time: '2 Minutes', label: 'AI Consultation', icon: 'ri-chat-4-line' },
              { time: '24-48 Hours', label: 'Deal Sourcing', icon: 'ri-search-line' },
              { time: '2-3 Days', label: 'Negotiation', icon: 'ri-hand-coin-line' },
              { time: '1 Week', label: 'Delivery', icon: 'ri-car-line' }
            ].map((item, idx) => (
              <div key={idx} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-2xl font-bold text-purple-600 mb-2">{item.time}</div>
                <div className="text-gray-700 font-semibold">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
